// extracted by mini-css-extract-plugin
export default {"postsContainer":"PostsSection_postsContainer__TOeRV","download":"PostsSection_download__sMUaG"};